import { z } from "zod/v4";

/**
 * Manual-reconcile form validation schema.
 *
 * Used by the operations dashboard's reconcile dialog when a domain
 * was registered out-of-band: the admin supplies the registrar's
 * reference and the confirmed expiry date so the registration can be
 * moved to Active.
 *
 * `expiresAt` is an ISO 8601 calendar date (`YYYY-MM-DD`) — the value
 * an `<input type="date">` produces. The submit handler converts it to a
 * full UTC ISO-8601 datetime (appending `T00:00:00Z`) before sending to
 * the backend.
 */
export const domainReconcileSchema = z.object({
  registrarReference: z
    .string()
    .trim()
    .min(1, "Registrar reference is required")
    .max(200, "Registrar reference must not exceed 200 characters"),
  expiresAt: z
    .string()
    .date("Expiry date must be a valid calendar date (YYYY-MM-DD)")
    .refine(
      (v) => new Date(v) > new Date(),
      "Expiry date must be in the future",
    ),
});

export type DomainReconcileFormData = z.infer<typeof domainReconcileSchema>;
